module.exports = __webpack_public_path__ + "img/pd-img38.5c2333f5.jpg";